var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00006 0.25C4.41427 0.25 4.75006 0.585786 4.75006 1V2.66763C7.5778 2.4158 10.4223 2.4158 13.2501 2.66763V1C13.2501 0.585786 13.5858 0.25 14.0001 0.25C14.4143 0.25 14.7501 0.585786 14.7501 1V2.81644C16.2431 3.02754 17.4226 4.20847 17.6223 5.71484L17.7089 6.36779C18.0729 9.11412 18.0414 11.8984 17.6155 14.6359C17.4045 15.9919 16.3028 17.0335 14.9371 17.1681L13.7441 17.2858C10.589 17.5969 7.41103 17.5969 4.25599 17.2858L3.06298 17.1681C1.69724 17.0335 0.595582 15.9919 0.384573 14.6359C-0.0413856 11.8984 -0.0728263 9.11412 0.291209 6.36779L0.377761 5.71484C0.577438 4.20845 1.75699 3.02751 3.25006 2.81643V1C3.25006 0.585786 3.58585 0.25 4.00006 0.25ZM4.44523 4.2028C7.47441 3.90408 10.5256 3.90408 13.5548 4.2028L14.4603 4.2921C15.327 4.37757 16.0209 5.04854 16.1353 5.91194L16.2219 6.56489C16.2521 6.793 16.2795 7.02139 16.3039 7.25H1.69612C1.72061 7.02139 1.74797 6.79301 1.7782 6.5649L1.86475 5.91194C1.9792 5.04854 2.67303 4.37757 3.53977 4.2921L4.44523 4.2028ZM1.57689 8.75C1.47871 10.6381 1.57544 12.5332 1.86674 14.4052C1.97258 15.0854 2.52515 15.6078 3.21019 15.6754L4.4032 15.793C7.46034 16.0945 10.5397 16.0945 13.5969 15.793L14.7899 15.6754C15.4749 15.6078 16.0275 15.0854 16.1333 14.4052C16.4246 12.5332 16.5214 10.6381 16.4232 8.75H1.57689Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.11c0b65d6704e47713437e58090784e9.svg";
export { ForwardRef as ReactComponent };